/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-youtube': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.381 5.787a2.188 2.188 0 00-1.544-1.543C15.475 3.875 10 3.875 10 3.875s-5.475 0-6.838.369A2.188 2.188 0 001.62 5.787c-.255 1.39-.378 2.8-.369 4.213-.01 1.413.114 2.823.369 4.213.202.752.79 1.34 1.544 1.543 1.362.369 6.837.369 6.837.369s5.475 0 6.837-.369a2.188 2.188 0 001.544-1.543c.255-1.39.378-2.8.369-4.213a22.581 22.581 0 00-.369-4.213zM8.25 12.625v-5.25L12.794 10 8.25 12.625z"/>'
  }
})
